import React from 'react';
import Reveal from '@/components/Reveal';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import { FAQS } from '@/data/metaOffer';

export default function MetaFaq() {
  return (
    <section id="faq" className="bg-white border-t border-[#0B0B0B]/10 py-20 lg:py-28">
      <div className="max-w-[1320px] mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-12">
        <Reveal className="lg:col-span-4">
          <span className="text-[11px] font-semibold uppercase tracking-[0.2em] text-[#2563EB] block mb-4">
            Frequently Asked Questions
          </span>
          <h2 className="font-display font-bold text-[#0B0B0B] tracking-tight text-3xl lg:text-4xl leading-tight">
            Answered before you ask
          </h2>
          <p className="mt-6 text-[#0B0B0B]/60 font-light leading-relaxed">
            Still unsure? Request the breakdown — it costs nothing and the findings are yours regardless of whether we
            work together.
          </p>
        </Reveal>

        <div className="lg:col-span-8">
          <Accordion type="single" collapsible className="w-full">
            {FAQS.map((f, i) => (
              <AccordionItem key={f.q} value={`faq-${i}`} className="border-[#0B0B0B]/10">
                <AccordionTrigger className="text-left font-display font-semibold text-[#0B0B0B] text-base lg:text-lg hover:text-[#2563EB] hover:no-underline py-6">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-[#0B0B0B]/60 font-light leading-relaxed text-[15px] pb-6">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}